import { createActionsHook, createHook, createStore, type Action } from 'react-sweet-state';

type State = {
	isOpen: boolean;
	isOverlaid: boolean;
	shouldCloseGracefully: boolean;
};

const initialState: State = {
	isOpen: false,
	isOverlaid: false,
	shouldCloseGracefully: false,
};

const actions = {
	setIsOpen:
		(isOpen: boolean): Action<State> =>
		({ setState }) => {
			setState({ isOpen });
		},
	setIsOverlaid:
		(isOverlaid: boolean): Action<State> =>
		({ setState }) => {
			setState({ isOverlaid });
		},
	setShouldCloseGracefully:
		(shouldCloseGracefully: boolean): Action<State> =>
		({ setState }) => {
			setState({ shouldCloseGracefully });
		},
	setHasClosedGracefully:
		(): Action<State> =>
		({ setState, getState }) => {
			const { isOpen } = getState();
			if (!isOpen) {
				setState({ shouldCloseGracefully: false, isOverlaid: false });
			}
		},
} as const;

type Actions = typeof actions;

const store = createStore<State, Actions>({
	initialState,
	actions,
	name: 'backlog-bulk-actions-bar',
});

export const useBulkActionsBar = createHook(store);

export const useBulkActionsBarActions = createActionsHook(store);
